module.exports = ".head-logo {\n  margin-top: -1.1vw; }\n"